import * as React from 'react';

import { ChipProps, useTheme } from '@mui/material';
import { InformationChip } from '../InformationChip';

export const STATUS_VALUES = ['pending', 'error', 'sent'] as const;
export const statusConfig = {
    pending: {
        color: 'warning',
        label: 'En attente',
    },
    error: {
        color: 'error',
        label: 'Erreur',
    },
    sent: {
        color: 'success',
        label: 'Envoyé',
    },
};
type StatusType = (typeof STATUS_VALUES)[number] | undefined | null;

export interface ChipStatusProps extends Omit<ChipProps, 'color' | 'icon'> {
    status: StatusType | string;
}
export const ChipStatus: React.FunctionComponent<ChipStatusProps> = function ({
    status,
    ...props
}) {
    const theme = useTheme();

    if (status === undefined || status === null) {
        return null;
    }

    const isValidStatus = (STATUS_VALUES as readonly string[]).includes(status);

    if (!isValidStatus) {
        return (
            <InformationChip
                variant="l2dtableCell"
                color={theme.palette.grey[300]}
                label={status}
                {...props}
            />
        );
    }

    const config = statusConfig[status as keyof typeof statusConfig];

    return (
        <InformationChip
            variant="l2dtableCell"
            color={config.color as ChipProps['color']}
            label={config.label}
            {...props}
        />
    );
};
